import React, {Component} from 'react';
import './Profile.css';
import {observer} from 'mobx-react';
import SubHeader from './SubHeader';
import UserInformation from './UserInformation/UserInformation';
import PersonalData from './PersonalData/PersonalData';

@observer
export default class Profile extends Component {
  
  render () {
    const divStyle = {
      marginTop: '0px'
    };
    return (
      <div className="Profile">
        <SubHeader onExportClick={this.onExport} />
        <div className="userData">
          <UserInformation style={divStyle}/>
          <PersonalData style={divStyle}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Profile/Profile.js